/**
 * Defines the keys for CMCD (Common Media Client Data) version 1.
 *
 * @public
 */
export const CMCD_V1_KEYS = [
	'bl',
	'br',
	'bs',
	'cid',
	'd',
	'dl',
	'mtp',
	'nor',
	'nrr',
	'ot',
	'pr',
	'rtp',
	'sf',
	'sid',
	'st',
	'su',
	'tb',
	'v',
] as const
